import photo1 from "@/assets/team-1.jpg";
import photo2 from "@/assets/team-2.jpg";
import photo3 from "@/assets/team-3.jpg";
import photo4 from "@/assets/team-4.jpg";

export type TeamMember = {
  name: string;
  role: string;
  bio: string;
  photo: string;
  initials: string;
  accent: string;
};

export const TEAM: TeamMember[] = [
  {
    name: "Marcelo Aguiar",
    role: "Editor-chefe — Gestão Empresarial",
    bio: "Coordena a redação da Empresa Brasil Online. Escreve sobre gestão, estratégia e governança para empresas que crescem no mercado brasileiro.",
    initials: "MA",
    accent: "#F07A1A",
    photo: photo1,
  },
  {
    name: "Camila Rezende",
    role: "Editora — Empreendedorismo",
    bio: "Cobre empreendedorismo, pequenas e médias empresas e histórias de negócios brasileiros que escalam com processo e propósito.",
    initials: "CR",
    accent: "#111111",
    photo: photo2,
  },
  {
    name: "Thiago Bastos",
    role: "Editor — Finanças & Controladoria",
    bio: "Escreve sobre finanças corporativas, controladoria, fluxo de caixa, tributos e indicadores que sustentam decisões empresariais no Brasil.",
    initials: "TB",
    accent: "#F07A1A",
    photo: photo3,
  },
  {
    name: "Patrícia Vasconcelos",
    role: "Editora — Liderança & Pessoas",
    bio: "Cobre liderança, cultura organizacional, gestão de pessoas e desenvolvimento de times em empresas brasileiras de todos os portes.",
    initials: "PV",
    accent: "#111111",
    photo: photo4,
  },
];
